'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

var makeObject = function makeObject() {
  return {};
};

_TransmuteCollection.keyedEquivalent.implement(Array, makeObject);
_TransmuteCollection.keyedEquivalent.implement(Object, makeObject);
_TransmuteCollection.keyedEquivalent.implementInherited(_immutable.Collection, function () {
  return (0, _immutable.Map)();
});
_TransmuteCollection.keyedEquivalent.implementInherited(_immutable.Seq, function () {
  return _immutable.Seq.Keyed();
});

exports.default = _TransmuteCollection.keyedEquivalent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.10/internal/_keyedEquivalent.js
// module id = 614
// module chunks = 3 4 5